export const collapsibleText = () => {
  const collapsibleText = '.js-collapsible-text';
  const collapsibleTextToggle = '.js-collapsible-text-toggle';
  const maxHeight = '15em';
  let collapsibleTextTotalHeight = 0;

  const init = () => {
    bind();
    layout();
  };

  const bind = () => {
    $(collapsibleTextToggle).on('click', function(e) {
      e.preventDefault();
      $(this).closest(collapsibleText).attr('data-state',
        $(this).closest(collapsibleText).attr('data-state')=='closed' ? 'open' : 'closed'
      );
      if($(this).closest(collapsibleText).attr('data-state') == 'open') {
        $(this).closest(collapsibleText).css({'max-height':collapsibleTextTotalHeight});
        $(this).closest(collapsibleText).removeClass('has-gradient');
      } else {
        $(this).closest(collapsibleText).css({'max-height':'15em'});
        $(this).closest(collapsibleText).addClass('has-gradient');
      }
    });

    $(collapsibleTextToggle).hover(
  	  function() {
  	    $(this).closest('.js-collapsible-text').addClass('is-hoverstate');
  	  }, function() {
  	    $(this).closest('.js-collapsible-text').removeClass('is-hoverstate');
  	  }
  	);

    $('body').on('window-watcher:resize', (e) => {
      layout();
    });
  };

  const layout = () => {
    collapsibleTextTotalHeight = 0;

    $('.js-collapsible-text .js-collapsible-text-content').each(function() {
      collapsibleTextTotalHeight = collapsibleTextTotalHeight + $(this).outerHeight(true);
  	});

  	$('.js-collapsible-text[data-state="open"]').css({'max-height':9999});
  };

  init();

};
